import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Location} from "@angular/common";
import {AdminUrlService} from "../services";
import {ContactActionTypeEnum} from "../../../global/enums";
import {ActivatedRoute} from "@angular/router";
import {TabsetComponent} from "ng-uikit-pro-standard";
import {User} from '../../../global/interfaces';
import {UserService} from '../../../global/services';

@Component({
  templateUrl: './whos-who.component.html',
  styleUrls: ['./whos-who.component.scss'],
})
export class WhosWhoComponent implements OnInit, AfterViewInit {

  @ViewChild('tabs') uiTabs: TabsetComponent;

  selectedTab = null;

  public ContactActionType = ContactActionTypeEnum;
  page = 1;
  queryString = "";

  currentUser: User;

  constructor(private location: Location, private adminURLService: AdminUrlService,
              private route: ActivatedRoute, private userService: UserService) {
    this.page = this.route.snapshot.params.page;
    this.queryString = this.route.snapshot.queryParamMap.get('query');

    this.userService.loadCurrentUser().then(() => {
      this.currentUser = this.userService.CurrentUser;

      // Initialize selectedTab after currentUser is loaded
      const urlTabIndex = this.route.snapshot.params.setTab || 1;
      this.setActiveTabFromUrl(urlTabIndex);
    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    if (this.selectedTab) {
      const visibleTabs = this.getTabMapping();
      const tabIndex = visibleTabs.findIndex(tab => tab.id === this.selectedTab);
      if (tabIndex !== -1) {
        this.uiTabs.setActiveTab(tabIndex);
      }
    }
  }

  getTabMapping() {
    const tabs = [
      {id: 'whoswho', originalIndex: 1, adminOnly: false},
      {id: 'listingsended', originalIndex: 2, adminOnly: false},
      {id: 'expiringsoon', originalIndex: 3, adminOnly: false},
      {id: 'stoppedadvertising', originalIndex: 4, adminOnly: true},
      {id: 'toplogins', originalIndex: 5, adminOnly: true},
      {id: 'recentlogins', originalIndex: 6, adminOnly: false},
      {id: 'recentsearches', originalIndex: 7, adminOnly: false},
      {id: 'topadvertviews', originalIndex: 8, adminOnly: false},
      {id: 'loginattempts', originalIndex: 9, adminOnly: false},
      {id: 'inactivecustomers', originalIndex: 10, adminOnly: false},
      {id: 'recentoffers', originalIndex: 11, adminOnly: true},
      {id: 'watchlistusers', originalIndex: 12, adminOnly: false},
      {id: 'messagestoseller', originalIndex: 13, adminOnly: true},
      {id: 'unverifiedcontacts', originalIndex: 14, adminOnly: false},
      {id: 'advertisingelsewhere', originalIndex: 15, adminOnly: false}
    ];

    return tabs.filter(tab => !tab.adminOnly || (this.currentUser && this.currentUser.isAdmin));
  }

  setActiveTabFromUrl(urlTabIndex: number) {
    const visibleTabs = this.getTabMapping();
    const tabData = visibleTabs.find(tab => tab.originalIndex === urlTabIndex);

    if (tabData) {
      this.selectedTab = tabData.id;
    } else {
      this.selectedTab = visibleTabs[0]?.id || 'whoswho';
    }
  }

  updateUrl($event: any) {
    const activeTabIndex = this.uiTabs.getActiveElement().activeTabIndex;
    const visibleTabs = this.getTabMapping();
    const selectedTabData = visibleTabs[activeTabIndex];

    if (selectedTabData) {
      this.selectedTab = selectedTabData.id;

      this.location.replaceState(this.adminURLService.adminWhosWho(selectedTabData.originalIndex, 1, true));
    }
  }
}
